import React, { ComponentType } from 'react';
import { RouteWrapper } from '@/components/routing/RouteErrorBoundary';

export const withErrorBoundary = (
  Component: ComponentType<any> | React.ReactElement
): React.ReactElement => {
  if (React.isValidElement(Component)) {
    return <RouteWrapper>{Component}</RouteWrapper>;
  }
  const ComponentToRender = Component as ComponentType<any>;
  return <RouteWrapper><ComponentToRender /></RouteWrapper>;
};